import styled from '@emotion/styled';

const InputLayout = styled.div<{ isFocus?: boolean }>`
  display: flex;
  align-items: center;
  border-radius: 8px;
  border: 1px solid #e7e9ec;
  background-color: white;
  height: 44px;
  padding-right: 12px;
  border-color: ${({ isFocus }) => (isFocus ? 'black' : '')};
  &:hover {
    border-color: black;
  }
`;

export { InputLayout };
